import Image from 'next/image';

import type { Reward } from './rewards';

export const PickemRewardCard = ({
  reward,
  index,
}: {
  reward: Reward;
  index: number;
}) => {
  return (
    <div className="relative flex h-[320px] w-full flex-col overflow-hidden rounded-lg bg-[url('/icons/gocore-logo-full.svg')] bg-center bg-contain bg-no-repeat text-center">
      <div className="absolute inset-0 bg-custom-gradient">
        <div className="relative flex h-full flex-col items-center justify-between p-6 px-12">
          {/* Prize Number */}
          <div className="relative z-10 mb-4">
            <div className="relative skew-x-12 rounded-lg border border-blue-gray/50">
              <div className="absolute inset-0 rotate-180 rounded-lg bg-custom-gradient shadow-prizeNumber" />
              <div className="-skew-x-12 px-6 py-2 font-semibold text-xl">
                {index + 1}.
              </div>
            </div>
          </div>

          {/* Image Container */}
          <div className="relative flex w-full flex-1 items-center justify-center">
            {/* Background Effects */}
            <div className="absolute inset-0 mx-auto h-full w-2/3">
              <div className="mt-2 border-blue-gray border-t-2 bg-custom-gradient" />
              <div className="absolute h-4/5 w-full bg-custom-gradient-3" />
              <div className="absolute h-1/2 w-full bg-dark-blue-ellipse-gradient" />
            </div>

            {/* Image */}
            <Image
              alt={reward.label}
              className="relative z-10 max-h-[120px] max-w-[120px] object-contain"
              height={120}
              src={reward.imagePath}
              width={120}
            />
          </div>

          {/* Label */}
          <div className="relative z-10 mt-4 flex flex-col items-center gap-0">
            <h3 className="font-semibold text-lg">{reward.label}</h3>

            {reward.price && (
              <span className="bottom-0 left-0 mt-2 rounded-lg bg-light-blue p-1 font-semibold text-black text-sm">
                {reward.price}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
